export default "__VITE_ASSET__CfjngBsH__"